import { isLarge, type LargeUploadWithS3, type Upload, UploadStatus } from '@air/redux-uploader';

export const isCurrentUploadSession = ({
  currentUpload,
  upload,
}: {
  currentUpload: Upload | undefined;
  upload: LargeUploadWithS3;
}) =>
  !!currentUpload &&
  isLarge(currentUpload) &&
  currentUpload.status === UploadStatus.uploading &&
  currentUpload.s3Info.uploadUrlInfo?.UploadId === upload.s3Info.uploadUrlInfo.UploadId;
